import { MarketingEmailLogDto } from "src/api-service";

// **************************************************************************
// EMAIL LOGS STATE
// **************************************************************************
export interface EmailLogsState {
    logs: MarketingEmailLogDto[] | undefined;
    loading: boolean;
}

export const initialEmailLogsState: EmailLogsState = {
    logs: undefined,
    loading: false,
};
